import { createSelector } from 'reselect';

import { RootState } from 'client/redux/index';

export const selectMuxDetails = (store: RootState) => {
  return store.muxDetails;
};

export const selectMuxDetailsToken = createSelector(selectMuxDetails, (muxDetails) => {
  return muxDetails.token;
});

export const selectMuxDetailsIsBusy = createSelector(selectMuxDetails, (muxDetails) => {
  return muxDetails.isBusy;
});

export const selectIsBroadcasting = createSelector(selectMuxDetails, (muxDetails) => {
  return muxDetails.isBroadcasting;
});

export const selectMuxDetailsMicWarn = createSelector(selectMuxDetails, (muxDetails) => {
  return muxDetails.microphoneError;
});

export const selectPreferredAudioOutput = createSelector(selectMuxDetails, (muxDetails) => {
  return muxDetails.preferredAudioOutput;
});
